import { jsxs as V, jsx as b } from "react/jsx-runtime";
import { useState as T, useRef as B, useEffect as x } from "react";
import { p as q } from "./common-utils-DjDyp7mO.mjs";
import { h as K, A as J, a as z } from "./common-utils-DEsnppYk.mjs";
const U = (n) => {
  var L, P, S, E;
  const {
    item: t,
    depthLevel: r,
    index: l,
    currentFocusMenu: u,
    totalSubmenus: h,
    styles: i,
    updateCurrFocusedIndex: c,
    textSizeClass: D,
    itemCountDown: w,
    parentDropdownLength: C,
    parentName: A,
    enableAnalytics: I,
    isLastItem: M,
    hideSelf: o,
    parentRef: p
  } = n, [g, a] = T(!1), [s, d] = T(!1), [F, R] = T(!1), m = B(null), f = B(null);
  x(() => {
    l === u && (m != null && m.current) && m.current.focus();
  }, [u, m.current]), x(() => () => {
    f.current && clearTimeout(f.current);
  }, []);
  const v = ((P = (L = t == null ? void 0 : t.HstMenuItemRepresentation) == null ? void 0 : L.parameters) == null ? void 0 : P.showDropdown) === "true", k = !!((E = (S = t == null ? void 0 : t.HstMenuItemRepresentation) == null ? void 0 : S.menuItems) != null && E.length), N = {
    color: F ? i.linkTextColorHover : i.linkTextColor,
    backgroundColor: "#FFFFFF"
  };
  F && (N.backgroundColor = i.navTabHoverBackgroundColor);
  const O = () => {
    f.current && (clearTimeout(f.current), f.current = null), a(v && k), R(!0);
  }, Y = (e) => {
    var H;
    if (e.relatedTarget && e.relatedTarget instanceof Node && ((H = p == null ? void 0 : p.current) != null && H.contains(e.relatedTarget))) {
      a(!1), R(!1), d(!1);
      return;
    }
    R(!1), d(!1), f.current = setTimeout(() => {
      a(!1);
    }, 250);
  }, _ = () => {
    a(!1), c(l), d(!1);
  }, j = (e, H) => {
    switch (e.key) {
      case "ArrowDown": {
        e.preventDefault(), e.stopPropagation(), M || c((u ?? 0) + 1);
        return;
      }
      case "ArrowRight": {
        e.preventDefault(), e.stopPropagation(), v && k && (c(null), a(!0), d(!0));
        return;
      }
      case "ArrowUp": {
        e.preventDefault(), e.stopPropagation(), l > 0 && c((u ?? 0) - 1);
        return;
      }
      case "Escape": {
        e.preventDefault(), e.stopPropagation(), o == null || o();
        return;
      }
      case "ArrowLeft": {
        r > 1 && (e.preventDefault(), e.stopPropagation(), o == null || o());
        return;
      }
      case "Enter": {
        H && (e.preventDefault(), e.stopPropagation());
        return;
      }
      default:
        return;
    }
  }, $ = `${A} | ${t.HstMenuItemRepresentation.name}`, y = t.HstMenuItemRepresentation.disabled;
  return /* @__PURE__ */ V(
    "li",
    {
      onMouseEnter: O,
      onMouseLeave: Y,
      className: `menu-items menu-items-${r} ${D} ${y && "u-disabled"}`,
      role: "menuitem",
      children: [
        /* @__PURE__ */ V(
          "a",
          {
            tabIndex: u === l ? 0 : -1,
            onClick: (e) => {
              y ? (e.preventDefault(), e.stopPropagation()) : I && K(
                e,
                J.NAV_TRAY,
                $,
                t.HstMenuItemRepresentation.parameters.analyticsSatellite
              );
            },
            onKeyDown: (e) => j(e, y),
            ref: m,
            className: `${F ? "" : "u-linkClean"} u-flex u-flexAlignItemsCenter u-flexJustifyBetween u-paddingHoriz16 u-paddingVert8 u-posRelative ${y && "u-disabled"}`,
            style: N,
            "data-analytics": $,
            href: q.sanitize(t.HstMenuItemRepresentation.url),
            "aria-expanded": g,
            "aria-haspopup": v && k ? "true" : "false",
            children: [
              t.HstMenuItemRepresentation.name,
              " ",
              v && k && /* @__PURE__ */ b(
                "span",
                {
                  className: "adel-material-symbols-18 arrow-right",
                  role: "img",
                  "aria-label": "Chevron Right",
                  children: "chevron_right"
                }
              )
            ]
          }
        ),
        g && /* @__PURE__ */ b(
          G,
          {
            depthLevel: r,
            parentRef: p,
            submenus: t.HstMenuItemRepresentation.menuItems || [],
            dropdown: g,
            styles: i,
            totalSubmenus: h,
            textSizeClass: D,
            countDownOffset: w,
            parentDropdownLength: C,
            parentName: $,
            enableAnalytics: I,
            focusFirstItem: s,
            setDropDownVisible: _
          }
        )
      ]
    }
  );
}, G = ({
  submenus: n,
  dropdown: t,
  depthLevel: r,
  styles: l,
  textSizeClass: u,
  countDownOffset: h,
  parentDropdownLength: i,
  parentName: c,
  enableAnalytics: D,
  focusFirstItem: w,
  setDropDownVisible: C,
  parentRef: A
}) => {
  const [I, M] = T(w ? 0 : null);
  r = r + 1;
  const o = +r > 1 ? "dropdown-submenu" : "";
  let p = 0;
  const g = h + n.length - 1 < i && +r > 1 ? "dropdown--square" : "";
  return x(() => {
    M(w ? 0 : null);
  }, [w]), n.length > 0 && /* @__PURE__ */ b(
    "ul",
    {
      className: `dropdown ${o} ${t ? "show" : "u-hidden"} ${g}`,
      role: "menu",
      children: n.map((a, s) => {
        const d = z(n[s]);
        return p += s === 0 ? 0 : z(n[s - 1]), /* @__PURE__ */ b(
          U,
          {
            item: a,
            depthLevel: r,
            index: s,
            totalSubmenus: d,
            styles: l,
            currentFocusMenu: I,
            itemCountDown: s + h,
            parentDropdownLength: n.length - 1,
            updateCurrFocusedIndex: M,
            textSizeClass: u,
            parentName: c,
            enableAnalytics: D,
            isLastItem: s === n.length - 1,
            hideSelf: C ? () => C() : null,
            parentRef: A
          },
          a.HstMenuItemRepresentation.name
        );
      })
    }
  );
};
export {
  G as D,
  U as a
};
//# sourceMappingURL=Dropdown-DaeGKBFi.mjs.map
